import React, { useState } from "react";
import MapDisplay from "./MapDisplay";
import CHElement from "../../../model/CHElement";
import Button from "../button/Button";
import ButtonAction from "../button/ButtonAction";
import ButtonType from "../button/ButtonType";
import MapMarkerData from "../../../model/MapMarkerData";

interface MapModalProps {
  data: CHElement[];
  title: string;
  onModalClose: () => void;
  onUpdateLocation?: (marker: MapMarkerData) => void;
  isInputEnabled?: boolean;
  fitToEurope?: boolean;
}

function MapModal({
  data,
  title,
  onModalClose,
  onUpdateLocation = (marker: MapMarkerData) => {},
  isInputEnabled = false,
  fitToEurope = true,
}: MapModalProps) {
  const [definedMarker, setDefinedMarker] = useState<MapMarkerData | undefined>(
    undefined,
  );
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined,
  );

  // Handle clicks on the overlay (background)
  const handleOverlayClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent clicks from bubbling up to the parent
    // Close the modal if the click is on the overlay (not the content)
    if (event.target === event.currentTarget) {
      // onModalClose();
    }
  };

  // Handle clicks inside the modal content
  const handleContentClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent clicks inside the content from bubbling up
  };

  const onLocationSelect = (marker: MapMarkerData) => {
    setDefinedMarker(marker);
  };

  const closeAndSave = () => {
    // check if we have a marker defined
    if (!definedMarker) {
      setErrorMessage(
        "Please click on the map to indicate the desired location.",
      );
      return;
    }
    onUpdateLocation(definedMarker);
    onModalClose();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-w-6xl h-4/5"
        onClick={handleContentClick}
      >
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <div className="flex-grow overflow-hidden h-[calc(100%-7rem)]">
          <MapDisplay
            data={data}
            isInputEnabled={isInputEnabled}
            fitToEurope={fitToEurope}
            onLocationSelect={onLocationSelect}
            className="w-full h-full"
          />
        </div>
        <div className="form-buttons-container pt-5">
          {!isInputEnabled && (
            <Button
              purpose={ButtonAction.CANCEL}
              type={ButtonType.FILL_ICON_TEXT}
              onClick={() => onModalClose()}
              label="Close"
            />
          )}
          {isInputEnabled && (
            <>
              <Button
                purpose={ButtonAction.CANCEL}
                type={ButtonType.FILL_ICON_TEXT}
                label="Cancel"
                onClick={() => onModalClose()}
              />
              <Button
                purpose={ButtonAction.SAVE}
                type={ButtonType.FILL_ICON_TEXT}
                label="Use selected coordinates"
                onClick={() => closeAndSave()}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MapModal;
